import { useMemo, useState } from 'react';

import createContextFactory from '@/utils/factory';

function useAppFactory() {
  const [sidebarCollapse, setMenuCollapsed] = useState(true)
  const [filterCollapsed, setFilterCollapsed] = useState(false)

  return useMemo(() => ({
    sidebarCollapse, setMenuCollapsed,
    filterCollapsed, setFilterCollapsed,
  }), [sidebarCollapse, filterCollapsed])
}

export const {
  Provider: AppLayoutProvider,
  useContext: useAppLayoutContext,
} = createContextFactory(useAppFactory)
